import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { Filter } from 'src/app/shared/models/filter';
import { Response } from 'src/app/shared/models/service';
import { ProfessionalTransfersService } from 'src/app/shared/services/professional-transfers.service';
import { FormatDateUtil } from 'src/app/shared/utils/format-date-util';

@Component({
  selector: 'app-professional-transfers-modal',
  templateUrl: './professional-transfers-modal.component.html',
  styleUrls: ['./professional-transfers-modal.component.scss']
})
export class ProfessionalTransfersModalComponent implements OnInit {
  showList = false
  data = this.config.data
  professionalData: any
  constructor(
    public config: DynamicDialogConfig,
    private professionalTransfersService: ProfessionalTransfersService,
    private fb: FormBuilder
  ) { }

  form = this.fb.group({
    dinheiro: '0',
    banco: '0',
    split: '0',
    total: '0',
    balance: '0',
    previousBalance: '0'
  });

  protected datePipe = new DatePipe("pt-BR");

  protected optionsReport = [
    { label: 'Ganho esperado', value: 1 },
    { label: 'Repasses realizados', value: 2 }
  ];

  protected selectedOption: any = this.optionsReport[0];

  protected listRepost: any = [];

  protected totalPageProfessionalRepost: number = 0;
  protected totalPageProfessionalList: number = 0;

  protected filterProfessionalList = new Filter();

  protected filterProfessionalRepost = new Filter();

  protected date: Date = new Date();

  ngOnInit(): void {

    let {before, after, unit} = this.data;
    this.filterProfessionalList.date("date", before, "before");
    this.filterProfessionalList.date("date", after, "after");
    console.log(FormatDateUtil.convertStringInDate(before));
    this.date = FormatDateUtil.convertStringInDate(before);
    if(unit) {
      this.filterProfessionalList.filter('unit', unit);
    }

    this.loadSumRevenueProfessional();
    this.loadProfessionalRepost();
    this.loadProfessionalList();

  }

  loadSumRevenueProfessional() {
    this.professionalTransfersService.getProfessionalPaymentInfoByID(this.data.id, this.filterProfessionalList.convertFilterInQuery()).subscribe({
      next: (res: any) => { this.patchCards(res[0]) },
      error: (err: any) => { console.log('Ocorreu um erro: ', err) }
    })
  }


  loadProfessionalList() {
    this.professionalTransfersService.getProfessionalListByID(this.data.id, this.filterProfessionalList.convertFilterInQuery()).subscribe({
      next: (res: Response<any>) => { 
        this.totalPageProfessionalList = res.total as number;
        this.patchList(res.data);
      },
      error: (err: any) => { console.log('Ocorreu um erro: ', err) }
    });
  }

  loadProfessionalRepost() {
    let {before, after, unit} = this.data;
    this.filterProfessionalRepost.date("date", before, "before");
    this.filterProfessionalRepost.date("date", after, "after");
    if(unit) {
      this.filterProfessionalRepost.filter('unit', unit);
    }
    this.professionalTransfersService.getProfessionalRepost(this.data.id, this.filterProfessionalRepost.convertFilterInQuery()).subscribe(
      {
        next: (res: Response<any>) => { 
          this.listRepost = res.data;
          this.totalPageProfessionalRepost = res.total as number;
         },
        error: (err: any) => { console.log('Ocorreu um erro: ', err) }
      })

  }


  patchCards(apiData: any) {
    let total = Number(apiData.professional_value) + Number(apiData.unit_value)
    this.form.patchValue({
      dinheiro: apiData.moneyAmount,
      banco: apiData.bankAmount,
      total: apiData.totalAmount, 
      split: apiData.cardAmount,
      balance: apiData.balance,
      previousBalance: apiData.previousBalance
    })
  }

  patchList(res: any) {
    let newList = res.map((obj: any) => {
      let parts = obj.date.split('-')
      parts.reverse()

      return {
        ...obj,
        date: `${parts[0]}/${parts[1]}/${parts[2]}`
      }
    })

    this.professionalData = newList
    this.showList = true
  }

  downloadCSV() {
    this.professionalTransfersService.getCSVProfessionalListByID(this.data.id, this.filterProfessionalList.convertFilterInQuery()).subscribe({
      next: (res: any) => {
        const file = new Blob([res], {
          type: res.type
        })

        const blob = window.URL.createObjectURL(file);

        const link = document.createElement('a');
        link.href = blob;
        link.download = `Relatorio ${this.data.name}.csv`;

        link.click();

        window.URL.revokeObjectURL(blob);
        link.remove();
      },
      error: (err: any) => { console.log('Ocorreu um erro: ', err) }
    })
  }

  pageChangeProfessionalList(event: any) { 
    this.filterProfessionalList.page(event.page);
    this.loadProfessionalList();
  }

  pageChangeProfessionalRepost(event: any) { 
    this.filterProfessionalRepost.page(event.page);
    this.loadProfessionalRepost();
  }

  setAppointmentTypeFilter(event: any) {
    this.selectedOption = event;
  }

}


